import { Link } from "@mui/material";
import DesktopEventPageMapButton from "../DesktopEventPageMapButton";
import { useNavigate } from "react-router-dom";
import FilterCountry from "./FilterCountry";
import FilterPhotographer from "./FilterPhotographer";
import FilterActivity from "./FilterActivity";
import FilterGalleryEvent from "./FilterGalleryEvent";
import FilterDate from "./FilterDate";
import { useEventFiltersDispatcher } from "../hooks/useEventFiltersDispatcher";
import { makeLogger } from "../../utils/logger";
import { useReduxStateReconcilation } from "../hooks/useReduxStateReconcilation";

const logger = makeLogger({
  enabled: true,
  label: "DesktopEventPageFilter",
  color: "pink",
});

export default function DesktopEventPageFilter({ gallery_event_name }) {
  useReduxStateReconcilation();
  const eventPageCtx = useEventFiltersDispatcher();
  const navigate = useNavigate();

  const handleClearFiltersClick = () => {
    logger.log("Reset all filter");
    eventPageCtx.updateAllListFilters({
      gallery_type: "event",
      gallery_event: undefined,
      activity_tags: undefined,
      shot_at_date_from: undefined,
      shot_at_date_to: undefined,
      photographers: undefined,
      // never clear country or search with this
      // any_field: undefined,
      // country: undefined,
      _callSource: "DesktopEventPageFilter",
    });
    navigate(`/customer/events/`);
  };

  return (
    <>
      <DesktopEventPageMapButton />
      <h4>
        Filter by:
        <Link
          size="small"
          sx={{
            cursor: "pointer",
            marginLeft: "24px",
            fontSize: "14px",
            fontWeight: "normal",
            ...(eventPageCtx.hasActiveFilters ? {} : { visibility: "hidden" }),
          }}
          onClick={handleClearFiltersClick}
        >
          clear all
        </Link>
      </h4>
      <FilterCountry />
      <FilterGalleryEvent />
      <FilterDate />
      <FilterActivity />
      <FilterPhotographer />
    </>
  );
}
